import {RSAA} from "redux-api-middleware";
import {fetchGameInfoAction} from "../Core/myResultsActions";

export const HTH_SEARCH = 'HTH_SEARCH';
export const HTH_SET_TEAM = 'HTH_SET_TEAM';
export const HTH_SET_TEAMS_LIST = 'HTH_SET_TEAMS_LIST';
export const HTH_INIT = 'HTH_INIT';

const searchAction = (position, teams) => ({
    type: HTH_SEARCH,
    payload: {
        teams, position
    }
});

export const loadHeadToHead = (gameId) => (dispatch, getState) => {
    let currentGame = getState().games.current;
    if (!currentGame || currentGame.id != gameId) {
        dispatch(fetchGameInfoAction({id: gameId})).then(() => dispatch(openHth()));
    } else {
        openHth()
    }
};

export const hthSearchUpdateAction = (position, classificationId, subleagueId, subleagueOpenId) => (dispatch, getState) => {

    let result = getState().headToHead.teamsList.find(e =>
            e.classificationId == classificationId &&
            e.subleagueId == subleagueId &&
            e.subleagueOpenId == subleagueOpenId
        ) || null;

    if (!result) {
        dispatch(
            hthFetchTeamsList(
                classificationId,
                subleagueId,
                subleagueOpenId,
                result => {
                    dispatch(searchAction(
                        position,
                        result
                    ));
                }
            )
        );
        return;
    }
    dispatch(searchAction(position, result.teams))
};

const setTeamAction = (team, position) => ({
    type: HTH_SET_TEAM,
    payload: {
        team, position
    }
});

const setTeamFirstFreeAction = (team) => (dispatch, getState) => {
    let teamLeft = getState().headToHead.teams.left.team;
    if (teamLeft) {
        dispatch(setTeamAction(team, 'right'));
        return;
    }
    dispatch(setTeamAction(team, 'left'));
};

const initAction = (columns, subleagues, subleaguesOpen, team) => ({
    type: HTH_INIT,
    payload: {
        columns,
        subleagues,
        subleaguesOpen,
        team
    }
});

const hthFetchTeamsList = (classificationId, subleagueId, subleagueOpenId, callback) => (dispatch, getState) => {
    let endpoint;
    if (subleagueId) {
        endpoint = `/api/v1/game/${getState().games.current.id}/prizeSubleague/${subleagueId}/teamsWithPoints/${classificationId}`;
    } else if (subleagueOpenId) {
        endpoint = `/api/v1/game/${getState().games.current.id}/openSubleague/${subleagueId}/teamsWithPoints/${classificationId}`;
    } else if (classificationId) {
        endpoint = `/api/v1/game/${getState().games.current.id}/classification/${classificationId}/teamsWithPoints`;
    }


    dispatch({
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                dispatch({
                                    type: HTH_SET_TEAMS_LIST,
                                    payload: {
                                        classificationId,
                                        subleagueOpenId,
                                        subleagueId,
                                        teams: json.data
                                    }
                                });
                                callback(json.data);
                            }
                        )
                    )
                },
                'FAILURE'
            ]
        }
    });
};

export const openHth = (team) =>
    (dispatch, getState) => {
        if (getState().headToHead.show) {
            if (team) {
                dispatch(setTeamFirstFreeAction(team));
            }
            return;
        }

        dispatch({
            [RSAA]: {
                endpoint: `/api/v1/game/${getState().games.current.id}/initHth`,
                method: 'GET',
                credentials: 'same-origin',
                types: [
                    'REQUEST',
                    {
                        type: 'SUCCESS',
                        payload: (action, state, res) => (
                            res.json().then(
                                json => {
                                    dispatch(initAction(
                                        json.data.columns,
                                        json.data.subleagues,
                                        json.data.subleaguesOpen,
                                        team
                                    ));
                                    if (team) {
                                        dispatch(setTeamFirstFreeAction(team));
                                    }
                                }
                            )
                        )
                    },
                    'FAILURE'
                ]
            }
        });
    };

export const hthFetchTeamAction = (teamId, position) => (dispatch, getState) => dispatch({
    [RSAA]: {
        endpoint: `/api/v1/game/${getState().games.current.id}/team/${teamId}/details/simple`,
        method: 'GET',
        credentials: 'same-origin',
        types: [
            'REQUEST',
            {
                type: 'SUCCESS',
                payload: (action, state, res) => (
                    res.json().then(
                        json => {
                            dispatch(setTeamAction(
                                json.data, position
                            ));
                        }
                    )
                )
            },
            'FAILURE'
        ]
    }
});